import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import he from './locales/he.json';

export const SUPPORTED_LANGUAGES = ['en', 'he'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export function isSupported(lang: string): lang is SupportedLanguage {
  return (SUPPORTED_LANGUAGES as readonly string[]).includes(lang);
}

export function baseTag(lang: string): string {
  return lang.toLowerCase().split(/[-_]/, 1)[0];
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      he: { translation: he },
    },
    supportedLngs: SUPPORTED_LANGUAGES as unknown as string[],
    fallbackLng: 'en',
    load: 'languageOnly',
    interpolation: { escapeValue: false },
    detection: {
      // Anonymous users: always follow the device language so switching the
      // browser locale takes effect on next load. Authenticated users have
      // their choice stored server-side (see LocaleProvider), which overrides
      // this detection once `/api/me/` resolves. A cached localStorage value
      // would defeat both paths (sticky-wrong for device changes; redundant
      // for logged-in users), so we deliberately skip it.
      order: ['navigator'],
      caches: [],
    },
    returnNull: false,
  });

export default i18n;
